import React, { Component } from "react";

class ServiceFeatureBox extends Component {
  render() {
    return (
      <div className="heading-bx">
        <h1 className="title mb-0 h3">
          HÅLL DIN BIL I TOPPSKICK MED REGELBUNDEN SERVICE
          <br /> OCH PROFESSIONELLA REPARATIONER!
        </h1>
        <p className="pt-4">
          Regelbunden service är nyckeln till en säker och pålitlig bil. På Kungälv Bilskadecenter erbjuder vi kompletta
          servicelösningar, från oljebyte och filterbyte till omfattande reparationer. Våra tekniker är specialiserade
          på alla bilmärken och använder originaldelar för att säkerställa kvalitet och lång livslängd på din bil.
        </p>
        <p>
          Vi erbjuder även diagnostik för att identifiera och åtgärda problem innan de blir allvarliga. Oavsett om det
          gäller bromsar, motor eller elektronik kan du lita på vår expertis. Dessutom garanterar vi snabb service utan
          att kompromissa med kvaliteten.
        </p>
        <p>
          Låt oss hjälpa dig att hålla din bil i toppskick och minska risken för oväntade problem. Boka en tid idag för
          service eller reparation.
        </p>
      </div>
    );
  }
}

export default ServiceFeatureBox;
